

 <ng2-flatpickr #flatpickrComponent placeholder="No date selected" [config]="flatpickrOptions"
    formControlName="formControlName">
    <span class="icon-plick"></span>
</ng2-flatpickr>